import { cn } from "@/utils/cn";

interface ILoaderProps {
  /** Diameter in px. */
  size?: number;
  className?: string;
}

/** CSS spinner; the ring uses `currentColor`, as in the mini app. */
export default function Loader({ size = 24, className }: ILoaderProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn("inline-block animate-spin rounded-full border-2 border-current border-t-transparent", className)}
      style={{ width: size, height: size }}
    />
  );
}
